// Toggle show elements, elements can be tag, id or class
window.toggleElement = function (elements) {
  const items = document.querySelectorAll(elements)
  Array.prototype.slice.call(items).forEach((i) => {
    i.classList.toggle('hidden')
  })
}
